import { ready } from '../utils/readyinit';
import initCartPage from '../sections/cart/initCartPage';
import initCartRecommendations from '../sections/cart/initCartRecommendations';

ready(() => {
  initCartPage();
  initCartRecommendations();
});
